<template src="./RelatedProduct.html"></template>
<style lang="scss" scoped src="./RelatedProduct.scss"></style>

<script>
import {
  SfHeading,
  SfLink,
  SfImage,
  SfIcon,
  SfNotification
} from '@storefront-ui/vue';
import {OrkLoader} from "@/components/Ork";

import {Navigation, Pagination, Autoplay} from 'swiper'

import {SwiperCore, Swiper, SwiperSlide} from 'swiper-vue2'

import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Autoplay])

import OrkProductCart from "@/components/Ork/OrkProductCart";

import icons from "@/utils/icons";

export default {
  name: "RelatedProduct",
  components: {
    SfHeading,
    SfIcon,
    SfLink,
    SfImage,
    SfNotification,
    OrkLoader,
    Swiper,
    SwiperSlide,
    OrkProductCart
  },
  props: {
    loading: {default: true,},
    products: {default: null,},
    headingTitle: {
      default: null,
      type: String || null
    },
    subHeadingTitle: {
      default: null,
      type: String || null
    },
    errorMessage: {
      default: null,
      type: String || null
    },
    error: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      icons: icons
    }
  },

  computed: {
    productsComputed: {
      get() {
        return this.products
      }
    }
  },
  watch: {
    productsComputed(val) {
      return val;
    },
    error(val) {
      return val;
    }
  }
}

</script>